import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import TinyColor2 from 'tinycolor2';

import { isLightColor } from '@mssgme/helpers';

import styles from './SocialLoginButton.scss';

export function SocialLoginButton({ as: Tag, icon: Icon, backgroundColor, iconBorderColor, style, children, ...rest }) {
    const color = isLightColor(backgroundColor) ? '#333' : '#eee';

    return (
        <Tag className={cn(styles.root, Icon && styles.hasIcon)} style={{ backgroundColor, color, ...style }} {...rest}>
            {Icon && (
                <div
                    className={styles.icon}
                    style={{
                        borderRight: `1px solid ${iconBorderColor ||
                            TinyColor2(backgroundColor)
                                .darken(4)
                                .toString()}`,
                    }}
                >
                    <Icon size={20} />
                </div>
            )}
            <div className={styles.content}>
                <div>{children}</div>
            </div>
        </Tag>
    );
}

SocialLoginButton.propTypes = {
    as: PropTypes.any,
    icon: PropTypes.any,
    backgroundColor: PropTypes.string,
    iconBorderColor: PropTypes.string,
    style: PropTypes.object,
    children: PropTypes.any.isRequired,
};

SocialLoginButton.defaultProps = {
    as: 'div',
    backgroundColor: '#fff',
    iconBorderColor: '',
};
